export default __webpack_public_path__ + "static/contact-tab-two-b05c5933b965fb258bbe21932ee8235d.jpg";